import { useMemo } from 'react';

import getBrowseInSearchCollectionsConfig from 'bundles/search-common/components/experiments/browseInSerp/getBrowseInSearchCollectionsConfig';
import {
  DEFAULT_SORTED_VALUE,
  NUMBER_OF_RESULTS_PER_PAGE,
  REQUEST_ORIGIN_PAGE_TYPE,
  REQUEST_ORIGIN_SEGMENT_TYPE,
  SEARCH_MAIN_INDEX_ID,
  SEARCH_SUGGESTIONS_INDEX_ID,
} from 'bundles/search-common/constants';
import { IS_PART_OF_COURSERA_PLUS, SEARCH_FILTERS_WITH_COST_FILTER } from 'bundles/search-common/constants/filter';
import type { SearchConfig } from 'bundles/search-common/providers/searchTypes';
import {
  getAutoApplyFiltersWithImpression,
  getShouldShowBrowseInSERP,
  isNlSuggestionQuery,
} from 'bundles/search-common/utils/experimentUtils';

export const getSearchConfigs = (showCourseraPlusFilter: boolean, query: string): SearchConfig[] => {
  const filterAttributes = showCourseraPlusFilter
    ? [...SEARCH_FILTERS_WITH_COST_FILTER, IS_PART_OF_COURSERA_PLUS]
    : SEARCH_FILTERS_WITH_COST_FILTER;

  const browseInSearchCollectionsConfig = getBrowseInSearchCollectionsConfig({ filterAttributes });
  const shouldEnableAutoAppliedFilters = getAutoApplyFiltersWithImpression();
  const shouldShowNlSuggestions = isNlSuggestionQuery(query);
  const searchResultConfig: SearchConfig[] = [
    {
      id: SEARCH_MAIN_INDEX_ID,
      entityType: 'PRODUCTS',
      limit: NUMBER_OF_RESULTS_PER_PAGE,
      facets: filterAttributes,
      syncQueryWithUrl: true,
      syncFiltersWithUrl: true,
      sortBy: DEFAULT_SORTED_VALUE,
      enableAutoAppliedFilters: shouldEnableAutoAppliedFilters,
      requestOrigin: {
        pageType: REQUEST_ORIGIN_PAGE_TYPE.SERP,
        segmentType: REQUEST_ORIGIN_SEGMENT_TYPE.CONSUMER,
      },
    },
    // used at the bottom of the SERP to suggest additional queries
    {
      id: SEARCH_SUGGESTIONS_INDEX_ID,
      entityType: 'SUGGESTIONS',
      limit: 10,
      syncQueryWithUrl: true,
      ...(shouldShowNlSuggestions && {
        searchContext: {
          searchSuggestedQueries: {
            _: shouldShowNlSuggestions,
          },
        },
      }),
    },
  ];
  if (getShouldShowBrowseInSERP() === true) {
    searchResultConfig.push(...browseInSearchCollectionsConfig);
  }
  return searchResultConfig;
};

export const useSearchConfigs = (showCourseraPlusFilter: boolean = false, query: string = ''): SearchConfig[] => {
  return useMemo(() => getSearchConfigs(showCourseraPlusFilter, query), [showCourseraPlusFilter, query]);
};

export default useSearchConfigs;
